import styled from 'styled-components';

export const SubtitleText = styled.h3<{ weight?: string }>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  font-weight: ${(props) => {
    switch (props.weight) {
      case 'light':
        return '100';
      case 'regular':
        return '500';
      case 'bold':
        return '700';
      default:
        return '500';
    }
  }};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  height: 35px;
  font-size: 15px;
  margin: 8px 0;
  width: 100%;
`;
